
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_LIFETIME_REQUEST,
  fetchLifeTimeRequest,
  fetchLifeTimeSuccess,
  fetchLifeTimeFailure,
  UPLOAD_EMAIL_REQUEST,
  uploadEmailSuccess,
  uploadEmailFailure,
  SEARCH_LIFETIME_REQUEST,
  searchLifeTimeSuccess,
  searchLifeTimeFailure
} from './lifeTimeAction';
import SDK from '../../config';

// Fetch lifetime data saga
function* fetchLifeTime(action) {
  const { page, limit } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/getcsvinfo?page=${page}&limit=${limit}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = yield response.json();
    yield put(fetchLifeTimeSuccess(data.data));
  } catch (error) {
    console.error('Fetch error:', error);
    yield put(fetchLifeTimeFailure(error.toString()));
  }
}

// Search lifetime data saga
function* searchLifeTime(action) {
  const { searchTerm } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/searchCsvEmail?searchTerm=${searchTerm}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = yield response.json();
    yield put(searchLifeTimeSuccess(data.data));
  } catch (error) {
    console.error('Fetch error:', error);
    yield put(searchLifeTimeFailure(error.toString()));
  }
}


// Upload email saga
function* uploadEmail(action) {
  try {
    const response = yield call(fetch, `${SDK.BASE_URL}/addEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: action.payload }),
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    yield put(uploadEmailSuccess());
    yield put(fetchLifeTimeRequest());
  } catch (error) {
    yield put(uploadEmailFailure(error.toString()));
  }
}


function* lifeTimeSaga() {
  yield takeLatest(FETCH_LIFETIME_REQUEST, fetchLifeTime);
  yield takeLatest(SEARCH_LIFETIME_REQUEST, searchLifeTime)
  yield takeLatest(UPLOAD_EMAIL_REQUEST, uploadEmail);
}

export default lifeTimeSaga;
